import React, { useState } from 'react';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xbddrpwz';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.email,
          company: formData.company,
          phone: formData.phone,
          message: formData.message
        })
      });

      if (response.ok) {
        setStatus({ type: 'success', message: 'Thank you! We\'ll be in touch soon.' });
        setFormData({ fullName: '', email: '', company: '', phone: '', message: '' });
      } else {
        const data = await response.json();
        throw new Error(data.error || 'Something went wrong');
      }
    } catch (error) {
      setStatus({ type: 'error', message: error.message || 'Failed to send message. Please try again or contact us directly.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="sv-hero">
          <div className="sv-eyebrow">Contact Us</div>
          <h1 className="sv-title">Get in Touch with Our Team</h1>
          <p className="sv-subtitle">Connect with asset recovery experts who transform your returns, excess inventory, and end-of-life assets into recovered value. We provide custom solutions tailored to your business needs.</p>
        </div>

        <section className="sv-overview">
          <h2 className="sv-section-title">Why Contact Us</h2>
          <div className="sv-features-grid">
            <div className="sv-feature">
              <h4>Expert Consultation</h4>
              <p>Speak with our experienced team to understand how we can help optimize your asset recovery and inventory management.</p>
            </div>
            <div className="sv-feature">
              <h4>Custom Solutions</h4>
              <p>Get tailored solutions designed specifically for your industry, scale, and business objectives.</p>
            </div>
            <div className="sv-feature">
              <h4>Free Assessment</h4>
              <p>Receive a complimentary assessment of your current situation and potential value recovery opportunities.</p>
            </div>
            <div className="sv-feature">
              <h4>Rapid Response</h4>
              <p>Our team responds quickly to inquiries and can provide same-day quotes for urgent situations.</p>
            </div>
          </div>
        </section>

        <section className="sv-overview">
          <h2 className="sv-section-title">How We Can Help</h2>
          <ul className="sv-bullets sv-list">
            <li>IT Asset Disposition – Secure data destruction and asset recovery for end-of-life IT equipment</li>
            <li>Returns Processing – Streamline customer returns with strategic routing and value recovery</li>
            <li>Excess Inventory – Liquidate overstock and seasonal inventory to free up space and capital</li>
            <li>Store Closings – Complete liquidation services for retail locations and facilities</li>
            <li>Abandoned Freight – Resolve dock congestion and recover value from abandoned shipments</li>
            <li>Charitable Donations – Support communities while maximizing tax benefits</li>
          </ul>
        </section>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          <h2>Get in Touch</h2>
          <p>
            Connect with inventory experts who transform your returns and excess stock into recovered revenue. Custom solutions await.
          </p>
          <div style={{ marginTop: '32px' }}>
            <h3 style={{ fontSize: '20px', marginBottom: '16px', color: '#0f172a' }}>Contact Information</h3>
            <p style={{ marginBottom: '12px' }}>
              <strong>HEADQUARTERS</strong><br />
              1058 Branch Drive<br />
              Alpharetta, GA 30004
            </p>
            <p style={{ marginBottom: '12px' }}>
              <strong>PHONE</strong><br />
              <a href="tel:+18778739336" style={{ color: '#14b8a6', textDecoration: 'none' }}>(877) 873-9336</a> (Toll Free)<br />
              <a href="tel:+16786948347" style={{ color: '#14b8a6', textDecoration: 'none' }}>(678) 694-8347</a>
            </p>
            <p style={{ marginBottom: '12px' }}>
              <strong>EMAIL</strong><br />
              <a href="mailto:info@globoflo.com" style={{ color: '#14b8a6', textDecoration: 'none' }}>info@globoflo.com</a>
            </p>
          </div>
        </div>
        
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="company">Company</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="message">Tell us about your business and buying interests</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          
          {status.message && (
            <div className={`form-status ${status.type === 'success' ? 'success' : 'error'}`}>
              {status.message}
            </div>
          )}

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Contact Sales Team'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
